import React from 'react';
const PFFormikError = ({ touched, errors, field }) => {
  const fieldValue = field.split('.');

  if (fieldValue.length > 1) {
    const fistIndex = fieldValue[0];
    const secondIndex = fieldValue[1];

    if (
      fistIndex &&
      secondIndex &&
      touched &&
      Object.entries(touched).length > 0 &&
      errors &&
      Object.entries(errors).length > 0
    ) {
      return touched?.[fistIndex]?.[secondIndex] ? (
        <div style={{ color: 'red' }} className="px-1 errorStyle text-xs">
          {errors?.[fistIndex]?.[secondIndex] || null}
        </div>
      ) : null;
    }
    return null;
  }
  return touched &&
    Object.entries(touched).length > 0 &&
    errors &&
    Object.entries(errors).length > 0 &&
    field &&
    touched?.[field] ? (
    <div style={{ color: 'red' }} className="px-1 errorStyle text-xs">
      {errors?.[field] || null}
    </div>
  ) : null;
};

export default PFFormikError;
